











































import { defineComponent, onMounted, onUnmounted, ref, computed, useContext } from '@nuxtjs/composition-api';
import { SfNotification } from '~/components';
import { useUiNotification } from '~/composables';

export default defineComponent({
  name: 'NotificationBar',
  components: {
    SfNotification,
  },
  setup() {
    const { app: { i18n } } = useContext();
    const { notifications } = useUiNotification();
    const headerLeftOffset = ref(0);
    const expandedMap = ref(new Map<symbol, boolean>());
    const desktopPosition = computed(() => ({ left: headerLeftOffset.value + 'px' }));
    const charLimit = 130;

    const displayMessage = (message: string, id: symbol): string => {
      if (expandedMap.value.get(id) || message.length <= charLimit) {
        return message;
      }
      return message.slice(0, charLimit) + '...';
    };

    const toggleExpand = (id: symbol) => {
      expandedMap.value.set(id, !expandedMap.value.get(id));
      expandedMap.value = new Map(expandedMap.value);
    };

    const expandButtonText = (id: symbol): string => {
      const isExpanded = expandedMap.value.get(id);
      return isExpanded ? i18n.tc('Read less') : i18n.tc('Read more');
    };

    const updateHeaderLeft = () => {
      const headerContainer = document.querySelector('.sf-header__container');

      if (headerContainer) {
        headerLeftOffset.value = headerContainer.getBoundingClientRect().left;
      }
    };

    onMounted(() => {
      const headerContainer = document.querySelector('.sf-header__container');

      updateHeaderLeft();

      window.addEventListener('resize', updateHeaderLeft);

      if (headerContainer && window.ResizeObserver) {
        new ResizeObserver(updateHeaderLeft).observe(headerContainer);
      }
    });

    onUnmounted(() => {
      window.removeEventListener('resize', updateHeaderLeft);
    });

    return {
      notifications,
      desktopPosition,
      charLimit,
      expandedMap,
      displayMessage,
      toggleExpand,
      expandButtonText,
    };
  },
});
